import gql from "graphql-tag";
import { contactDetailsFields } from "../queries/getContactDetails";

export const UPDATE_CONTACT = gql`mutation updateContact($id: ID!, $updateContactInput: UpdateContactInput!) {
    updateContact(id: $id, updateContactInput: $updateContactInput) {
        ${contactDetailsFields}
    }
}`;
